import * as React from "react";

export const Checkmark = () => (
  <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.3085 2.08658L5.75315 10.6419C5.51482 10.8802 5.20194 11 4.88906 11C4.57618 11 4.2633 10.8802 4.02497 10.6419L0.358407 6.97533C-0.119469 6.49746 -0.119469 5.72504 0.358407 5.24716C0.836282 4.76928 1.60871 4.76928 2.08658 5.24716L4.88906 8.04964L12.5803 0.358407C13.0582 -0.119469 13.8306 -0.119469 14.3085 0.358407C14.7863 0.836282 14.7863 1.60871 14.3085 2.08658Z"
      fill="#D8D8D8"/>
  </svg>
);
